import { Injectable, inject } from '@angular/core';
import { ApiService } from '../core/http/api.service';
import { PortfolioMetadata } from '../models/classes/portfolio.class';
import { PortfolioSeriesMeta } from '../models/classes/portfolio-series-meta.class';

@Injectable({
  providedIn: 'root'
})
export class MetadataService {
  private apiService = inject(ApiService);
  fetchPortfolioMetadata(): Promise<PortfolioMetadata[]> {
    return new Promise((resolve, reject) => {
      this.apiService.getPortfoliosMetadata().subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (err) => {
          reject(err);
        }
      });
    })
  }

  fetchSeriesDashboardMetaData(seriesId: number, investorId: number): Promise<PortfolioSeriesMeta> {
    return new Promise((resolve, reject) => {
      this.apiService.getPortfolioSeriesDashboardMetadata(seriesId, investorId).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (err) => {
          reject(err);
        }
      });
    })
  }
}